import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { Candidate } from '@app/models/offer-letters/candidate.model';
import { OfferLetter } from '@app/models/offer-letters/offer-letter.model';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { DateSentColumn, OfferStatusColumn, SignatureStatusColumn } from './columns';

const downloadOption: MenuColumnItem = {
    label: 'Download',
    event: 'download',
};

@Injectable()
export class OfferLettersTable extends Table {
    links = false;
    showMenuColumnOptions = true;

    constructor(
        protected auth: AuthService,
        public candidate: Candidate,
        private translateService: TranslateService
    ) {
        super(auth);
        this.boot();
    }

    getMenuColumnOptionsForRow(offerLetter: OfferLetter): MenuColumnItem[] {
        if (offerLetter.isSigned()) {
            return [downloadOption];
        }
        return [];
    }

    setColumns(): void {
        this.columns = [
            new DateSentColumn(),
            new OfferStatusColumn(this.candidate, this.translateService.currentLang),
            new SignatureStatusColumn(),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            OfferLetter.with(['signingTemplate', 'signingTemplate.document', 'signatureRequest']).where(
                'candidate_id',
                this.candidate.id
            )
        );
    }
}
